package io.peekandpoke.kraft.i18n.generated

import io.peekandpoke.ultra.i18n.I18n
import io.peekandpoke.ultra.i18n.I18nTranslate

// Generated by the i18n codegen. Do not edit.

class FormsI18n(val i18n: I18n)
val I18nTranslate.forms: FormsI18n get() = FormsI18n(i18n)

fun FormsI18n.empty(): String =
    i18n.resolve("forms.empty")

fun FormsI18n.notEmpty(): String =
    i18n.resolve("forms.notEmpty")

fun FormsI18n.blank(): String =
    i18n.resolve("forms.blank")

fun FormsI18n.notBlank(): String =
    i18n.resolve("forms.notBlank")

fun FormsI18n.minLength(vararg forcedNamed: Unit, count: Int): String =
    i18n.resolvePlural("forms.minLength", count, emptyMap())

fun FormsI18n.maxLength(vararg forcedNamed: Unit, count: Int): String =
    i18n.resolvePlural("forms.maxLength", count, emptyMap())

fun FormsI18n.exactLength(vararg forcedNamed: Unit, count: Int): String =
    i18n.resolvePlural("forms.exactLength", count, emptyMap())

fun FormsI18n.validEmail(): String =
    i18n.resolve("forms.validEmail")

fun FormsI18n.validUrl(): String =
    i18n.resolve("forms.validUrl")

fun FormsI18n.validSlug(): String =
    i18n.resolve("forms.validSlug")

fun FormsI18n.nonNull(): String =
    i18n.resolve("forms.nonNull")

fun FormsI18n.equalTo(): String =
    i18n.resolve("forms.equalTo")

fun FormsI18n.notEqualTo(): String =
    i18n.resolve("forms.notEqualTo")

fun FormsI18n.anyOf(): String =
    i18n.resolve("forms.anyOf")

fun FormsI18n.noneOf(): String =
    i18n.resolve("forms.noneOf")

fun FormsI18n.invalidInput(): String =
    i18n.resolve("forms.invalidInput")

fun FormsI18n.invalidValue(): String =
    i18n.resolve("forms.invalidValue")

fun FormsI18n.joinOr(): String =
    i18n.resolve("forms.joinOr")

fun FormsI18n.joinAnd(): String =
    i18n.resolve("forms.joinAnd")

fun FormsI18n.inRange(vararg forcedNamed: Unit, from: Any?, to: Any?): String =
    i18n.resolve("forms.inRange", mapOf("from" to from, "to" to to))

fun FormsI18n.greaterThan(vararg forcedNamed: Unit, limit: Any?): String =
    i18n.resolve("forms.greaterThan", mapOf("limit" to limit))

fun FormsI18n.greaterThanOrEqual(vararg forcedNamed: Unit, limit: Any?): String =
    i18n.resolve("forms.greaterThanOrEqual", mapOf("limit" to limit))

fun FormsI18n.lessThan(vararg forcedNamed: Unit, limit: Any?): String =
    i18n.resolve("forms.lessThan", mapOf("limit" to limit))

fun FormsI18n.lessThanOrEqual(vararg forcedNamed: Unit, limit: Any?): String =
    i18n.resolve("forms.lessThanOrEqual", mapOf("limit" to limit))

fun FormsI18n.collectionNotEmpty(): String =
    i18n.resolve("forms.collectionNotEmpty")

fun FormsI18n.minCount(vararg forcedNamed: Unit, count: Int): String =
    i18n.resolvePlural("forms.minCount", count, emptyMap())

fun FormsI18n.maxCount(vararg forcedNamed: Unit, count: Int): String =
    i18n.resolvePlural("forms.maxCount", count, emptyMap())

fun FormsI18n.exactCount(vararg forcedNamed: Unit, count: Int): String =
    i18n.resolvePlural("forms.exactCount", count, emptyMap())

